<template>
    <!-- 上传订单 -->
    <div class="wrapper">
        <div class="main_wrapper">
            <div class="info_inner" v-if="status!=null">
                <div v-if="status">
                    <img src="../../assets/image/mini/success.png" class="success_img"/>
                    <div class="success_tip">{{msg}}</div>
                </div>
                <div v-else>
                    <img src="../../assets/image/mini/error.png" class="success_img"/>
                    <div class="error_tip">{{msg}}</div>
                </div>

                <div class="inner" v-if="clue">
                    <p>姓名：{{clue.name}}</p>
                    <p>电话：{{clue.phone}}</p>
                    <p>城市：{{clue.city_name}}</p>
                    <p>报名时间：{{clue.ctime_str}}</p>
                </div>
            </div>
            <img src="../../assets/image/mini/order.jpg" class="load_img" v-else>
        </div>
        <div @click="clk_svip" type="primary" class="footer_btn">核销订单</div>
    </div>

</template>

<script>

    import _wx from "@/common/_wx";
    import lib_wx from "@/libs/lib_wx";
    import lib_clue from "@/libs/lib_clue";
    import _url from "@/utils/_url";
    import _time from "@/utils/_time";

    export default {
        name: "svip",
        data() {
            return {
                expo_id: 0, //
                status: null,
                msg: '', //提示信息
                code: '', //二维码文本
                clue: null, //用户信息
            }
        },
        created() {
            document.title = '订单核销'
            this.expo_id = _url.getParam('id')

            lib_wx.parameter(this.init_config)
        },
        mounted() {
            const wrapper = this.$refs.wrapper
            console.log(wrapper, '===')
        },
        methods: {
            init_config(data) {

                const js_api_list = [
                    'checkJsApi',
                    'scanQRCode',
                ]

                _wx.js_api(data, null, null, js_api_list)
            },
            clk_svip() {
                _wx.scan(this.scan_success)
            },

            scan_success(res) {
                if (res.hasOwnProperty('resultStr')) {
                    const code = res.resultStr
                    lib_clue.checkorder(code, this.expo_id, this.scan_result)
                } else {
                    this.scan_result({code: -1, msg: '扫码无效'})
                }
            },

            scan_result(res) {
                if (res.code == 0) {
                    this.status = 1
                    this.msg = '核销成功'
                    this.clue = res.data
                    this.clue.ctime_str = _time._to_date(this.clue.ctime * 1000)
                } else {
                    this.status = 0
                    this.msg = res.msg
                    if (res.hasOwnProperty('data')) {
                        this.clue = res.data
                        this.clue.ctime_str = _time._to_date(this.clue.ctime * 1000)
                    }
                }
            },
        }
    }
</script>



<style scoped lang="less">
    .load_img{
        width: 100%;
        height: 100%;
        display: block;
    }
    .city_wrapper {
        width: 100%;
        height: 50px;
        background-color: #fff;
        position: fixed;
        // top: 44px;
        top: 0;
        left: 0;
        z-index: 10;
        // box-shadow: 0 0 10px 2px #ccc;
        color: #000;
        padding: 0 10px 0 20px;
        box-sizing: border-box;
        line-height: 60px;
        display: flex;
        align-items: center;
        font-size: 20px;

        // border-bottom: solid 1px #ccc;
        .address {
            width: 22px;
            height: 22px;
            margin-right: 5px;
        }

    }

    .city_list_wrapper {
        position: fixed;
        // top: 84px;
        top: 50px;
        width: 100%;
        height: calc(100% - 44px);
        overflow-y: auto;
        // box-shadow: 0 0 10px 2px #ccc;
        // height: 400px;
        background-color: #fff;
        z-index: 20;
        padding: 15px 0;
        box-sizing: border-box;

        span {
            display: inline-block;
            width: 33%;
            height: 40px;
            line-height: 40px;
            text-align: center;
            font-size: 18px;
        }

        span:active {
            background-color: #f5f4f5;
        }
    }


    // 底部按钮
    .footer_btn {
        width: 100%;
        height: 80px;
        background-color: blue;
        color: #fff;
        text-align: center;
        line-height: 80px;
        font-size: 36px;
    }

    // 主体部分
    .wrapper {
        width: 100vw;
        /*// height: calc(100vh - 44px);*/
        height: 100vh;
        /*padding-top: 40px;*/
        box-sizing: border-box;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        background-color: #f5f4f5;
    }

    .main_wrapper {
        width: 100vw;
        flex: 1;
        overflow-y: auto;

        // display: flex;
        // align-items: center;
        // justify-content: center;
        .info_inner {
            padding-top: 35px;
            box-sizing: border-box;

            .success_img,
            .error_img {
                display: block;
                width: 60px;
                height: 60px;
                margin: 10px auto;
            }

            .success_tip {
                font-size: 32px;
                color: #029b00;
                text-align: center;
            }

            .error_tip {
                font-size: 32px;
                color: orangered;
                text-align: center;
            }

            .inner {
                padding: 16px 10px 10px 40px;
                margin-top: 16px;

                p {
                    margin-bottom: 6px;
                    font-size: 30px;
                }
            }
        }
    }

    input {
        max-width: 640px;
        min-width: 320px;
    }

    .main_wrapper_text {
        width: 100%;
        height: 100%;
        padding: 20px;
        box-sizing: border-box;
        border: none;
        overflow: visible;
        word-break: break-all;
    }

    // 结果
    .result {
        width: 100%;
        height: 80px;
        line-height: 80px;
        text-align: center;
        color: red;
        font-size: 30px;
    }

    .error_info{

        margin-top: 80px;
        text-align: center;

        img{
            width: 140px;
            height: 140px;
        }
        h2{
            margin: 10px 0;
        }
        p{
            color: #3b3b3b;
            font-size: 28px;
        }
    }
</style>
